import { default as createReducer } from 'app/utils/create-reducer'
export default createReducer({}, {})
